const TYPE = "Cascade/PowerTree";

// Setup
export const SET_POWER_TREE_DATA = `${TYPE}/set_power_tree_data`;
export const RESET_SETUP = `${TYPE}/reset_setup`;
export const GET_POWER_TREE_SETTING = `${TYPE}/get_power_tree_setting`;
export const SAVE_CONNECTORS_TO_SETUP = `${TYPE}/save_connectors_to_bcakend`;
export const SAVE_ROOT_TO_SETUP = `${TYPE}/save_root_to_backend`;
export const SAVE_MULTI_RESULT = `${TYPE}/save_multi_results`;
export const SAVE_MULTI_SPICE_RESULT = `${TYPE}/save_multi_spice_results`;
export const SET_COMPONENT_AS_CONNECTOR = `${TYPE}/set_component_as_connector`;
export const SET_PONIT_CONNECTOR = `${TYPE}/set_point_connector`;